export default __webpack_public_path__ + "img/aboutusbg.8723b072.png";